// MessageBell.js
import React from 'react';
import { MessageCircle } from 'lucide-react';

function MessageBell({ role, count = 0, onClick }) {
  const hasUnread = count > 0;

  return (
    <button
      type="button"
      onClick={onClick}
      className="relative inline-flex items-center justify-center w-9 h-9 rounded-full hover:bg-purple-50 border border-transparent hover:border-purple-200 focus:outline-none focus:ring-2 focus:ring-purple-400"
      title={hasUnread ? `${count} unread messages` : 'Messages'}
    >
      <MessageCircle className="w-5 h-5 text-purple-600" />
      {hasUnread && (
        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-purple-600 text-white text-[10px] flex items-center justify-center">
          {count > 9 ? '9+' : count}
        </span>
      )}
    </button>
  );
}

export default MessageBell;

